import axios from 'axios'
import config from './config.js'
import { ElMessage } from 'element-plus'
import router from '../router/index'
import qs from 'qs'
const instance = axios.create({
  baseURL: config.BASE_URL,
  // timeout: 300000,
  withCredentials: true
})
instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
instance.interceptors.request.use(
  config => {
    // 获取缓存里面的token
    let userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      userInfo = JSON.parse(userInfo)
      config.headers['accountId'] = userInfo.id
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

function thenHandle(response) {
  if (response.status == 200) {
    if (response.data.httpCode == 401 || (response.data.httpCode == 409 && response.data.msg == '您还未登录')) {
      localStorage.clear()
      setTimeout(() => {
        router.push('/login')
      }, 1000)
    } else {
      return Promise.resolve(response.data)
    }
  } else if (response.status == 207) {
    ElMessage.error('操作过于频繁')
  } else {
    ElMessage.error('错误请求')
  }
}
function catchHandle(error) {
  const status = (error.response && error.response.status && error.response.status) || ''
  const data = (error.response && error.response.data) || {}
  if (data.message) {
    ElMessage.error(data.message)
  } else if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
    ElMessage.error('请求超时')
  } else if (status === 401 || status === 405) {
    localStorage.clear()
    setTimeout(() => {
      router.push('/login')
    }, 1000)
  } else if (status === 403) {
    ElMessage.error('API Forbid')
  } else if (status === 404) {
    ElMessage.error('404 API Not Found')
  } else {
    ElMessage.error('服务端故障')
  }
}
// get请求 封装
export function get(
  url,
  params,
  config = {
    forse: false
  }
) {
  let { forse } = config
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      const element = params[key]
      url += '/' + element
    }
  }
  return instance
    .get(url)
    .then(res => {
      if (forse) {
        Promise.resolve(res)
      } else {
        return thenHandle(res)
      }
    })
    .catch(err => {
      if (forse) {
        Promise.reject(err)
      } else {
        return catchHandle(err)
      }
    })
}
// geted请求 封装
export function geted(
  url,
  params,
  config = {
    forse: false
  }
) {
  let { forse } = config
  let str = ''
  for (const key in params) {
    if (Object.hasOwnProperty.call(params, key)) {
      const element = params[key]
      str += key + '=' + element + '&'
    }
  }
  url += '?' + str
  return instance
    .get(url)
    .then(res => {
      if (forse) {
        Promise.resolve(res)
      } else {
        return thenHandle(res)
      }
    })
    .catch(err => {
      if (forse) {
        Promise.reject(err)
      } else {
        return catchHandle(err)
      }
    })
}
// post请求 封装
export function post(
  url,
  data,
  config = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    forse: false
  }
) {
  let { headers, forse, responseType } = config
  let strData = qs.stringify(data)
  instance.defaults.headers = headers
  instance.defaults.responseType = responseType || ''
  if (headers['Content-Type'] == 'application/x-www-form-urlencoded') {
    data = strData
  } else if (headers['Content-Type'] == 'application/json') {
    data = data
  } else if (headers['Content-Type'] == 'multipart/form-data') {
    data = data
  }
  return instance
    .post(url, data)
    .then(res => {
      if (forse) {
        Promise.resolve(res)
      } else {
        return thenHandle(res)
      }
    })
    .catch(err => {
      if (forse) {
        Promise.reject(err)
      } else {
        return catchHandle(err)
      }
    })
}
export function wordpost(
  url,
  data,
  config = {
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    forse: false
  }
) {
  let { headers, forse } = config
  instance.defaults.headers = headers
  instance.defaults.responseType = 'blob'

  return instance
    .post(url, data)
    .then(res => {
      if (forse) {
        Promise.resolve(res)
      } else {
        return thenHandle(res)
      }
    })
    .catch(err => {
      if (forse) {
        Promise.reject(err)
      } else {
        return catchHandle(err)
      }
    })
}
export function postJson(
  url,
  data,
  config = {
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    forse: false
  }
) {
  let { headers, forse } = config
  instance.defaults.headers = headers
  instance.defaults.responseType = ''

  return instance
    .post(url, data)
    .then(res => {
      if (forse) {
        Promise.resolve(res)
      } else {
        return thenHandle(res)
      }
    })
    .catch(err => {
      if (forse) {
        Promise.reject(err)
      } else {
        return catchHandle(err)
      }
    })
}
